












/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";

import axios from "axios";
import { DateUtils } from "../../../BusinessServices/dateutils";
import ParticaTitleBase from "../../Base/ParticaTitleBase.vue";
import PublicationStatusLog from "../../../Ui-Components/Title/PublicationStatusLog.vue";
import { ApiAuditModel } from "../../../Generated/ParticaAPI";
import { IPublicationService } from "../../../BusinessServices/publication";


@Component(
	{
		name: "PublicationLog",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,
			PublicationStatusLog,
		}
	})
export default class PublicationLog extends ParticaTitleBase {
	@Prop() private id: number;
	private publicationService: IPublicationService;
	private logs: ApiAuditModel[] = [];
	private buttons: ButtonConfig[] = [
		// { label: "Add new title", action: eParticaAction.ISSUE_ADD, type: ButtonType.Normal } as ButtonConfig,
	];
	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Issue Status";
		this.publicationService = this.particaServices.getPublicationService();
		await this.init();
		await this.getTitleNav(this.id);
	}



	private async init() {
		try {
			this.LoadingStart();
			if (this.stateconfig.admin !== true) {
				return;
			}
			this.logs = await this.publicationService.getLogs(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
